<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Budgets
        <span class="separator" />
      </h1>
    </b-col>
    <ListeBudgets />
  </div>
</template>

<script>
import ListeBudgets from "@/components/budgets/ListeBudgets.vue";

export default {
  name: "Budgets",
  components: {
    ListeBudgets,
  },
};
</script>

<style lang="scss" scoped></style>
